import { render, staticRenderFns } from "./purchasedAdmin.vue?vue&type=template&id=a451c24c&scoped=true&"
import script from "./purchasedAdmin.vue?vue&type=script&lang=js&"
export * from "./purchasedAdmin.vue?vue&type=script&lang=js&"
import style0 from "./purchasedAdmin.vue?vue&type=style&index=0&id=a451c24c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a451c24c",
  null
  
)

export default component.exports